import { Tile, TileMap, PointerEvent } from "excalibur";

export type TileEvent = {
  tile: Tile;
  event: PointerEvent;
};

export function toTileEvent(
  pathmap: TileMap,
  onTile: (evt: TileEvent) => void,
) {
  return (evt: PointerEvent) => {
    const targetTile = pathmap.getTileByPoint(evt.coordinates.worldPos);
    if (!targetTile) return;
    onTile({ tile: targetTile, event: evt });
  };
}
